import { render } from "./Create.vue?vue&type=template&id=f3b6c64c"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
script.render = render

export default script